/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ValueData, ValueModel } from './value.component-model';
import { ViewComponentKey } from '../key/view-component.key';
import { ComponentFieldKey } from '../model/component.model';

export interface SelectInputOptions {
  values: string[];
  formattedValues: string[];
}

export interface SelectInputData extends ValueData {
  options?: string[];
  formattedOptions?: string[];
}

export class SelectInputFieldKey {
  static readonly OPTIONS = 'options';
  static readonly FORMATTED_OPTIONS = 'formattedOptions';
}

export class SelectInputModel extends ValueModel implements SelectInputData {
  static readonly KEYS = ValueModel.KEYS.concat(
    Object.keys(SelectInputFieldKey).map((key) => SelectInputFieldKey[key])
  );

  constructor(data?: SelectInputData, keys?: string[]) {
    super(data, keys || SelectInputModel.KEYS);
  }

  get options(): string[] {
    return this.get(SelectInputFieldKey.OPTIONS);
  }

  set options(value: string[]) {
    this.set(SelectInputFieldKey.OPTIONS, value);
  }

  get formattedOptions(): string[] {
    return this.get(SelectInputFieldKey.FORMATTED_OPTIONS);
  }

  set formattedOptions(value: string[]) {
    this.set(SelectInputFieldKey.FORMATTED_OPTIONS, value);
  }

  protected setupValues(values: SelectInputData, exclusive: boolean): SelectInputData {
    if (exclusive && !(ComponentFieldKey.TYPE in values)) {
      values.type = ViewComponentKey.SELECT_INPUT;
    }
    if (exclusive && !(ComponentFieldKey.TAB_INDEX in values)) {
      values.tabIndex = 0;
    }
    if (exclusive || SelectInputFieldKey.OPTIONS in values) {
      if (!(SelectInputFieldKey.FORMATTED_OPTIONS in values)) {
        values.formattedOptions = values.options;
      }
    }
    // TODO handle format
    return super.setupValues(values, exclusive) as SelectInputData;
  }
}
